// src/firebase.js
import { initializeApp } from "firebase/app";
import {
  getAuth,
  GoogleAuthProvider,
  signInWithPopup,
  signOut,
} from "firebase/auth";

// const firebaseConfig = {
//   apiKey: "AIzaSyCbo8F1Q6TEQsS03LmfoHRfnpRZg7YyzvE",
//   authDomain: "wisedesk-dev.firebaseapp.com",
//   projectId: "wisedesk-dev",
//   storageBucket: "wisedesk-dev.appspot.com",
//   messagingSenderId: "173190808865",
//   appId: "1:173190808865:web:e63487e53dbe3e77b66a60",
//   measurementId: "G-QEK9GYZ2GR",
// };

const firebaseConfig = {
  apiKey: "AIzaSyAcYMr-TcNl5yQ4_qfJ0Kn0KHFZNycAYLc",
  authDomain: "wisedesk-438010.firebaseapp.com",
  projectId: "wisedesk-438010",
  storageBucket: "wisedesk-438010.firebasestorage.app",
  messagingSenderId: "244868172093",
  appId: "1:244868172093:web:ab65174bec4a5003685d54",
  measurementId: "G-SMMQ3MY4Y0"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and Google provider
const auth = getAuth(firebaseApp);
const googleProvider = new GoogleAuthProvider();

export { auth, googleProvider, signInWithPopup, signOut };
